import $ from 'jquery';
import copy from '@data/0-default';

/**
 * greeting() renders a greeting based on the time in a html element with class 'js-day'
 */
const greeting = () => {
  const element = $('.js-greeting');
  if (element.length === 0) return;
  const currentDate = new Date();
  const currentTime = currentDate.getHours();
  const isMorning = currentTime >= 4 && currentTime < 12;
  const isAfternoon = currentTime >= 12 && currentTime < 17;
  let selectedGreeting;

  if (isMorning) {
    selectedGreeting = copy.greetings.morning;
  } else if (isAfternoon) {
    selectedGreeting = copy.greetings.afternoon;
  } else {
    selectedGreeting = copy.greetings.evening;
  }

  element.html(selectedGreeting);
};

export default greeting;
